module.exports = __webpack_public_path__ + "img/signup_carousel_3.59a6d330.svg";